import { AppDispatch } from '@/state/store';
import { useDispatch } from 'react-redux';

export function use_dispatch() {
  return useDispatch<AppDispatch>();
}
